var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay bg-white opacity-75",attrs:{"data-test-id":"loading-screen"}},[_c('loading-animation',{staticClass:"opacity-100",attrs:{"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }